import momentTimezone from 'moment-timezone';
import { isEmpty } from 'lodash';
import Cookies from 'universal-cookie';

const getScheduleResponse = (response) => {
  if (isEmpty(response?.schedules)) return [];

  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  return {
    noActiveHostScheduleCount: response?.noActiveHostScheduleCount,
    schedules: response?.schedules?.map((schedule, index) => {
      return {
        id: index,
        start: momentTimezone.tz(schedule?.startedAt, timezone).format('YYYY-MM-DD HH:mm:ss'),
        end: momentTimezone.tz(schedule?.endedAt, timezone).format('YYYY-MM-DD HH:mm:ss'),
        scheduleCount: schedule?.scheduleCount,
        areas: schedule?.areas,
        startedAt: schedule?.startedAt,
        endedAt: schedule?.endedAt,
        noActiveHostScheduleCount: schedule?.noActiveHostScheduleCount,
      };
    }),
  };
};

export default getScheduleResponse;
